// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","secondary":"_1vKx5z4Lo7YoK4x7oA44Cn","textDefault":"#808080","passwordWrapper":"BwG-GXZ0OWvBiFaBNNBvZ","password":"fy5tXnh72PWN8-89U_wiJ","border":"EMiNtD9esQ45P0z-9LcbB","centered":"_2ONCemmjyLFWXs0X2GArlF","eye":"_20m1Oei7nSnPtmqa_JRNkc","invalid":"t0Yz6NAAKy_ga4nBUx84t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordInput/PasswordInput.mod.css
// module id = 1077
// module chunks = 0